import React from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import Button from "component/atoms/button";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
/// Button UI
import SVGIcons from "assets/icon";
import Cache from "core/cache/index";

import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";

import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";
import { getEnabledElements } from "component/toolManager/enabledElements.js";
import { getToolState } from "component/toolManager/toolState.js";
import { Swal } from "component/util/swalShim.js";

@inject("sarcopeniaMeasureStore")
@inject("authStore")
@observer
@Autobind
class AnalysisPanel extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    closeProfileMenu: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    closeProfileMenu: () => {},
  };

  state = {
    isProcessing: false, // ✅ 버튼 비활성화 제어용 상태
  };

  handlePressL3AreaMeasureBtn = async (event) => {
    const { disabled, sarcopeniaMeasureStore, authStore, closeProfileMenu } =
      this.props;

    if (disabled === true || this.state.isProcessing) {
      return;
    }

    if (typeof closeProfileMenu === "function") {
      closeProfileMenu();
    }

    this.setState({ isProcessing: true }); // ✅ 버튼 비활성화 시작

    try {
      ReactGA.event({
        category: "AI Service",
        action: "Request sarcopenia analysis",
      });

      let metadataCache = new Cache.Metadata();
      const activeDataKey = metadataCache.getActiveDataKey();
      if (!activeDataKey) {
        return;
      }

      const frame = metadataCache.getFrame(activeDataKey, 0);
      const width = frame.width;
      const height = frame.height;
      const pixelSpacingX = frame.pixelSpacing[0];
      const pixelSpacingY = frame.pixelSpacing[1];
      const sliceThickness = frame.sliceThickness;
      const rescaleIntercept = frame.rescaleIntercept;
      const rescaleSlope = frame.rescaleSlope;

      const token = authStore.getToken();

      let pixelDataArray = Array.from(frame.pixelData);
      for (let i = 0; i < pixelDataArray.length; i++) {
        pixelDataArray[i] =
          pixelDataArray[i] * rescaleSlope + rescaleIntercept;
      }

      let pixelmask = 0;

      if (sarcopeniaMeasureStore._measureDatalist.length !== 0) {
        let totalEnabledElement = getEnabledElements();
        let mainEnabledElement = totalEnabledElement[0];
        let toolState = getToolState(
          mainEnabledElement.element,
          BaseBrushTool.getReferencedToolDataName()
        );

        const toolData = toolState.data;
        if (!toolData || !toolData[0] || !toolData[0].originalPixelData) return;
        pixelmask = toolData[0].originalPixelData;
      }

      const editmode = sarcopeniaMeasureStore.mode === "edit";
      const infer_status = authStore.getInfer();
      const mask_status = authStore.getMaskInfer();

      if (!editmode && infer_status) {
        const { isConfirmed } = await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "An analysis right will be deducted when you press OK",
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
        });
        if (!isConfirmed) return;
      }

      // if (editmode && mask_status) {
      //   const { isConfirmed } = await Swal.fire({
      //     icon: "warning",
      //     title: "Warning",
      //     text: "An analysis right will be deducted when you press OK",
      //     showCancelButton: true,
      //     confirmButtonText: "OK",
      //     cancelButtonText: "Cancel",
      //   });
      //   if (!isConfirmed) return;
      // }

      LoadingSnackbarManager.loading("Loading", -1);
      await sarcopeniaMeasureStore.requestMeasureSarcopenia(
        pixelDataArray,
        pixelmask,
        editmode,
        mask_status,
        width,
        height,
        pixelSpacingX,
        pixelSpacingY,
        sliceThickness,
        token
      );

      LoadingSnackbarManager.complete("Complete", 3000);
      if (editmode) {
        authStore.setMaskInfer(true);
      } else {
        authStore.setInfer(true);
      }
    } catch (error) {
      LoadingSnackbarManager.complete("Failed", 3000);
      if (error.redirect_url) {
        alert(error.message);
        window.open(error.redirect_url, "_blank");
      } else {
        alert("An error occurred. Please try again.");
      }
    } finally {
      this.setState({ isProcessing: false }); // ✅ 버튼 다시 활성화
    }
  };

  render() {
    return (
      <div className="control-item">
        <label className="item-title">{"Analysis"}</label>
        <div className="item-content">
          <Button
            svgIcon={<SVGIcons.SVGAnalysisIcon />}
            visible={true}
            type={"primary"}
            size={"full"}
            disabled={this.state.isProcessing} // ✅ 실행 중이면 비활성화
            style={{
              height: "38px", // ✅ 원하는 높이
              minHeight: "38px", // 라이브러리 기본값 override
              lineHeight: "38px",
              pointerEvents: this.state.isProcessing ? "none" : "auto",
              cursor: this.state.isProcessing ? "not-allowed" : "pointer",
            }}
            onPress={this.handlePressL3AreaMeasureBtn}
          >
            L3 Area Measure
          </Button>
        </div>
      </div>
    );
  }
}

export default AnalysisPanel;
